<script>
import { Cell, Field, Row, Col, Popup } from 'vant'
import TextSwitcher from '@/components/org/TextSwitcher'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-suspension-reminder-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-field': Field,
        'van-row': Row,
        'van-col': Col,
        'van-popup': Popup,
        'text-switcher': TextSwitcher
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                id: null,
                isSuspensionReminderOn: null,
                suspensionYellowCardNum: null,
                suspensionYellowCardGameNum: null,
                suspensionRedCardNum: null,
                suspensionRedCardGameNum: null,
                isSuspensionLeadKnockout: null,
                suspensionReportNum: null,
            },
            showPopup: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onIsLeadKnockoutDataChange(data) {
            if (data == this.match.isSuspensionLeadKnockout) {
                return
            }
            this.match.isSuspensionLeadKnockout = data
            this.submitData()
        },
        onIsReminderOnDataChange(data) {
            if (data == this.match.isSuspensionReminderOn) {
                return
            }
            this.match.isSuspensionReminderOn = data
            this.submitData()
        },
        onReminderIndicationClick() {
            this.showPopup = true
        },
        onYellowNumInput(data) {
            if (!data) {
                return
            }
            this.match.suspensionYellowCardNum = data
            this.submitData()
        },
        onYellowGameNumInput(data) {
            if (!data) {
                return
            }
            this.match.suspensionYellowCardGameNum = data
            this.submitData()
        },
        onRedNumInput(data) {
            if (!data) {
                return
            }
            this.match.suspensionRedCardNum = data
            this.submitData()
        },
        onRedGameNumInput(data) {
            if (!data) {
                return
            }
            this.match.suspensionRedCardGameNum = data
            this.submitData()
        },
        onReportBtnClick() {
            console.log('onReportBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchReport',
                    params: {
                        id: this.match.id
                    }
                }
            })
        },
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.match
            })
        },
        submitData() {
            console.log('submitData')
            this.$emit('custom-event', {
                type: 'submit',
                data: this.match
            })
        }
    },
}
</script>

<template>
    <div class="match-suspension-reminder-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <text-switcher 
            class="b-outer-margin"
            :label="locale['is-suspension-reminder-on-label']"
            :indicated="true"
            :checked="match.isSuspensionReminderOn"
            @click-indication="onReminderIndicationClick"
            @change-data="onIsReminderOnDataChange"
        />
        <div v-show="match.isSuspensionReminderOn">
            <van-row class="relative">
                <van-col span="12">
                    <van-field
                        v-model="match.suspensionYellowCardNum"
                        :label="locale['match-suspension-yellow-num-label']"
                        :placeholder="locale['match-suspension-yellow-num-placeholder']"
                        type="digit"
                        clearable
                        input-align="right"
                        maxlength="1"
                        @input="onYellowNumInput"
                    />
                </van-col>
                <van-col span="12">
                    <van-field
                        v-model="match.suspensionYellowCardGameNum"
                        :label="locale['match-suspension-yellow-game-num-label']"
                        :placeholder="locale['match-suspension-yellow-game-num-placeholder']"
                        type="digit"
                        clearable
                        input-align="right"
                        maxlength="1"
                        @input="onYellowGameNumInput"
                    />
                </van-col>
                <div class="separator-line-bottom"/>
            </van-row>
            <van-row class="relative">
                <van-col span="12">
                    <van-field
                        v-model="match.suspensionRedCardNum"
                        :label="locale['match-suspension-red-num-label']"
                        :placeholder="locale['match-suspension-red-num-placeholder']"
                        type="digit"
                        clearable
                        input-align="right"
                        maxlength="1"
                        @input="onRedNumInput"
                    />
                </van-col>
                <van-col span="12">
                    <van-field
                        v-model="match.suspensionRedCardGameNum"
                        :label="locale['match-suspension-red-game-num-label']"
                        :placeholder="locale['match-suspension-red-game-num-placeholder']"
                        type="digit"
                        clearable
                        input-align="right"
                        maxlength="1"
                        @input="onRedGameNumInput"
                    />
                </van-col>
                <div class="separator-line-bottom"/>
            </van-row>
            <text-switcher 
                class="b-outer-margin"
                :label="locale['is-suspension-lead-knockout-label']"
                :checked="match.isSuspensionLeadKnockout"
                @change-data="onIsLeadKnockoutDataChange"
            />
            <van-cell
                class="t-outer-margin"
                :title="locale['suspension-report-num-label']"
                :value="match.suspensionReportNum"
                is-link center
                @click="onReportBtnClick"
            />
        </div>
        <van-popup 
            class="popup-container"
            v-model="showPopup"
            position="top"
        >
            <div class="indicator-popup">
                <div class="title-section text-center">
                    <span class="main-title">{{ locale['reminder-indication'] }}</span>
                    <span class="close-btn" @click="showPopup = false">
                        <i class="iconfont iconfont-close-black"/>
                    </span>
                </div>
                <div class="summary u-outer-padding">
                    <span class="normal-text">{{ locale['reminder-summary'] }}</span>
                </div>
                <div class="content u-outer-padding">
                    <ol class="minor-text main-secondary-color">
                        <li>{{ locale['reminder-item-1'] }}</li>
                        <li>{{ locale['reminder-item-2'] }}</li>
                        <li>{{ locale['reminder-item-3'] }}</li>
                        <li>{{ locale['reminder-item-4'] }}</li>
                    </ol>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.van-popup--top {
    top: 90px;
	left: 24px;
	width: 327px;
	height: 270px;
	background: #FFFFFF;
    border-radius: 16px;
}
.title-section {
    margin-bottom: 14px;
}
.content li {
    margin-bottom: 12px;
}
</style>